import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-efficiency-analysis-config-dialog',
  templateUrl: './efficiency-analysis-config-dialog.component.html',
  styleUrls: ['./efficiency-analysis-config-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EfficiencyAnalysisConfigDialogComponent {
  public tabIndex = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matDialogRef: MatDialogRef<EfficiencyAnalysisConfigDialogComponent>,
  ) {}

  public close(): void {
    this.matDialogRef.close();
  }

  public isRecalculated(val: boolean): void {
    this.data.isRecalculated = val;
  }
}
